<template>
  <div :style="{ backgroundImage: `url(${loginBg})` }" class="login-container">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
      auto-complete="on"
      label-position="left"
    >
      <p class="logo"><img :src="logoSrc" alt="" /></p>
      <el-button class="title" type="text">{{ title }}</el-button>
      <template v-if="loginType === 'normal'">
        <el-form-item
          prop="username"
          :class="{ borderColor: active === 'username' }"
        >
          <span class="svg-container svg-container_login">
            <svg-icon icon-class="username" style="margin-left: -3px" />
          </span>
          <el-input
            v-model="loginForm.username"
            autofocus
            name="username"
            type="text"
            auto-complete="off"
            :placeholder="$t('login.username')"
            @keyup.enter.native="handleLogin"
            @focus="active = 'username'"
            @blur="active = ''"
          />
        </el-form-item>
        <el-form-item
          prop="password"
          :class="{ borderColor: active === 'password' }"
        >
          <span class="svg-container">
            <svg-icon icon-class="password" />
          </span>
          <el-input
            :type="pwdType"
            v-model="loginForm.password"
            name="password"
            auto-complete="on"
            :placeholder="$t('login.password')"
            @focus="active = 'password'"
            @blur="active = ''"
            @keyup.enter.native="handleLogin"
          />
          <!-- <span class="show-pwd" @click="showPwd">
            <svg-icon v-if="pwdType === 'password'" icon-class="eye"/>
            <svg-icon v-else icon-class="open_eye"/>
          </span> -->
        </el-form-item>
        <el-form-item
          v-if="showCode"
          prop="state"
          :class="{ borderColor: active === 'state' }"
        >
          <span class="svg-container">
            <svg-icon icon-class="catcha" />
          </span>
          <el-input
            v-model="loginForm.state"
            name="state"
            auto-complete="off"
            :placeholder="$t('login.state')"
            @focus="active = 'state'"
            @blur="active = ''"
            @keyup.enter.native="handleLogin"
          />
          <img
            class="catcha"
            :src="codeUrl"
            alt=""
            @click="time = new Date().getTime()"
          />
        </el-form-item>
        <el-form-item
          prop="solution"
          :class="{ borderColor: active === 'solution' }"
          v-if="!defaultSid || showSolutionSelector"
        >
          <span class="svg-container">
            <svg-icon icon-class="solution" />
          </span>
          <el-select
            ref="solutionSelector"
            v-model="loginForm.solution"
            placeholder=""
            @focus="active = 'solution'"
            @blur="active = ''"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              @click.native="handleSolutionChange(item)"
            />
          </el-select>
        </el-form-item>
        <div style="position: relative; z-index: 99">
          <el-checkbox v-model="useCookie">{{
            $t("login.remember")
          }}</el-checkbox>

          <el-button
            type="text"
            size="large"
            style="float: right; padding: 0"
            @click="handleResetPwd"
            >{{ $t("login.forget") }}?</el-button
          >
          <el-button
            type="text"
            size="large"
            style="float: right; padding: 0; margin-right: 10px"
            v-if="!showSolutionSelector"
            @click="showSolutionSelector = !showSolutionSelector"
            >所有应用</el-button
          >
          <el-button
            v-if="register"
            type="text"
            size="large"
            style="float: right; padding: 0; margin-right: 10px"
            @click="handleRegister"
            >注册</el-button
          >
        </div>
        <el-form-item style="border: none">
          <el-button
            v-waves
            :loading="loading"
            type="primary"
            size="big"
            style="width: 100%"
            @click.native.prevent="handleLogin"
          >
            {{ $t("login.logIn") }}
          </el-button>
        </el-form-item>
        <el-form-item style="border: none">
          <el-button
            type="text"
            size="large"
            disabled
            style="width: 100%; margin-top: 0px"
            v-if="!showSolutionSelector"
            >{{ currentSolutionName }}</el-button
          >
        </el-form-item>
      </template>
      <div
        v-if="loginType === 'wechatwork'"
        style="width: 450px; height: 400px"
        v-loading="thirdPartyLoading"
      >
        <wx-login
          v-if="!thirdPartyLoading"
          :state="state"
          :appid="wxAppid"
          :agentid="agentid"
          :redirect_uri="redirect_uri"
        ></wx-login>
      </div>
      <div
        v-if="loginType === 'dingTalk'"
        style="width: 450px; height: 400px"
        v-loading="thirdPartyLoading"
      >
        <ding-talk-login
          v-if="!thirdPartyLoading"
          :state="state"
          :appid="dingTalkAppid"
          :redirect_uri="redirect_uri"
        ></ding-talk-login>
      </div>
      <div v-if="loginType === 'ldap'">
        <ldap-login />
      </div>
      <div v-if="loginType === 'rtxwechat'">
        <rtx-login
          v-if="!thirdPartyLoading"
          :rtxApiHost="rtxApiHost"
          :state="state"
          :appid="rtxAppid"
          :agentid="agentid"
          :redirect_uri="redirect_uri"
        ></rtx-login>
      </div>
      <div class="thirdParty">
        <template v-for="(item, index) in buttons">
          <el-button
            type="text"
            :key="index"
            v-if="showThirdParty(item)"
            @click="handleLoginType(item)"
          >
            <svg-icon :icon-class="item" />
          </el-button>
        </template>
      </div>
    </el-form>
    <canvas-bg v-if="effectActive"></canvas-bg>
    <div class="foot_content" v-if="footContent && footContent.content">
      <el-link
        target="_blank"
        :href="footContent.url"
        :style="'color:' + (footContent.color || '#909399')"
      >
        {{ footContent.content }}
      </el-link>
    </div>
  </div>
</template>

<script>
import { getHash, setHash } from '@/utils/auth'
import thirdPartyLogin from '@/views/SSO/mixins/thirdPartyLogin'
import ldapLogin from './ldapLogin'
import dingTalkLogin from './dingTalkLogin'
import wxLogin from './wxLogin'
import rtxLogin from './rtxLogin'
import CanvasBg from './CanvasBg/index'
import { getOEMInfo } from '@/api/license'
import { getSolutionId, setSolutionList } from '@/utils/auth'
import { getRandomCode } from '@/utils'
import {
  getSolutions,
  getSystemSettings,
  getThirdParty,
  getTimestamps,
  getGlobalSetting
} from '@/api/login'
export default {
  name: 'Login',
  mixins: [thirdPartyLogin],
  components: {
    CanvasBg,
    wxLogin,
    dingTalkLogin,
    ldapLogin,
    rtxLogin
  },
  data() {
    return {
      timestamps: getHash(),
      rtxApiHost: '',
      rtxAppid: '',
      loginRtxWeixin: false,
      register: false,
      time: new Date().getTime(),
      showCode: false,
      wxState: null,
      dingState: null,
      loginDing: false,
      loginLdap: false,
      loginWorkWeixin: false,
      dingTalkAppid: '',
      thirdPartyLoading: false,
      buttons: ['normal', 'wechatwork', 'dingTalk', 'ldap', 'rtxwechat'],
      loginType: 'normal',
      defaultLoginType: null,
      wxAppid: '',
      agentid: '',
      redirect_uri: '',
      active: '',
      title: '企业业务数字化开发平台',
      loginForm: {
        username: '',
        password: '',
        solution: '',
        state: '',
        captchId: getRandomCode(8)
      },
      loginRules: {
        username: [
          { required: true, trigger: ['blur', 'change'], message: this.$t('login.usernameRequired') }
        ],
        state: [
          { required: true, trigger: ['blur', 'change'], message: this.$t('login.stateRequired') }
        ],
        // password: [{ required: true, trigger: 'blur', validator: validatePass }],
        solution: [{ required: true, trigger: 'blur', message: this.$t('login.solutionRequired') }]
      },
      loading: false,
      pwdType: 'password',
      options: [],
      effectActive: true,
      defaultSid: null,
      getSolutionCount: 0,
      waitingNotify: null,
      useCookie: localStorage.getItem('useCookie') ? eval(localStorage.getItem('useCookie').toLowerCase()) || false : false,
      footContent: {
        content: '',
        url: '',
        color: '#909399'
      },
      showSolutionSelector: false
    }
  },
  created() {
    this.defaultSid = this.getUrlKey('sid')
    this.defaultLoginType = this.getUrlKey('loginType')
    this.$store.dispatch('setImprovePwd', '')
    this.getRedirect()
    this.getSolutions()
    this.getOEMInfo()
    this.getFootContent()
    if (localStorage.getItem('loginForm')) {
      this.$set(this, 'loginForm', Object.assign({}, JSON.parse(localStorage.getItem('loginForm'))))
    }
    this.loginForm.state = ''
    this.loginForm.captchId = getRandomCode(8)
  },
  mounted() {
    this.$refs.loginForm.clearValidate()
    localStorage.removeItem('fillInfo')
  },
  computed: {
    // 额外登录参数
    loginParams() {
      const params = this.$route.query || {}
      return params
    },
    logoSrc() {
      if (this.loginForm.solution && this.timestamps) {
        // return process.env.BASE_API + '/solutions/0/images'
        return `${process.env.BASE_API}/solutions/${this.loginForm.solution}/images?key=0&t=${this.timestamps['0']}`
      }
    },
    loginBg() {
      if (this.loginForm.solution && this.timestamps) {
        // return process.env.BASE_API + '/solutions/1/images'
        return `${process.env.BASE_API}/solutions/${this.loginForm.solution}/images?key=1&t=${this.timestamps['1']}`
      }
    },
    codeUrl() {
      return process.env.BASE_API + `/captch?sid=${this.loginForm.solution}&captchId=${this.loginForm.captchId}&_t=${this.time}`
    },
    state() {
      if (this.loginType === 'wechatwork') {
        return this.wxState + '@' + this.loginType
      } else if (this.loginType === 'dingTalk') {
        return this.dingState + '@' + this.loginType
      } else if (this.loginType === 'rtxwechat') {
        return this.wxState + '@' + this.loginType
      } else {
        return null
      }
    },
    currentSolutionName() {
      if (this.defaultSid && this.options) {
        var findResult = this.options.find(item => item.id.toUpperCase().indexOf(this.defaultSid.toUpperCase()) === 0)
        if (findResult) {
          return findResult.name
        }
      }
      return ''
    }
  },
  watch: {
    loginType(newVal) {
      localStorage.setItem('loginType', newVal, { expires: 365 })
      this.thirdPartyLoading = false
      if (newVal === 'wechatwork') {
        if (!this.wxAppid || !this.agentid) {
          this.thirdPartyLoading = true
          this.getThirdParty(2)
        }
      } else if (newVal === 'dingTalk') {
        if (!this.dingTalkAppid) {
          this.thirdPartyLoading = true
          this.getThirdParty(3)
        }
      } else if (newVal === 'rtxwechat') {
        if (!this.rtxAppid || !this.agentid) {
          this.thirdPartyLoading = true
          this.getThirdParty(4)
        }
      }
    },
    'loginForm.solution': function (newVal) {
      this.getLoginViewSettings(newVal)
      const favicon = document.querySelector('link[rel="shortcut icon"]')
      favicon.href = `${process.env.BASE_API}/solutions/${getSolutionId()}/images?key=3`
    },
    immediate: true
  },
  methods: {
    getUrlKey(name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    },
    setUrlKey(name, value) {
      var url = location.href
      if (url.indexOf(name + '=') > 0) {
        var urlPart = url.split('?')
        var paramPart = urlPart[1].split('&')
        paramPart.forEach((item, index) => {
          if (item.indexOf(name + '=') >= 0) {
            var namePart = item.split('=')
            paramPart[index] = namePart[0] + '=' + value
          }
        })
        url = urlPart[0] + '?' + paramPart.join('&')
      } else {
        if (url.indexOf('?') > 0) {
          url += `&${name}=${value}`
        } else {
          url += `?${name}=${value}`
        }
      }
      console.log(url)
      history.replaceState(null, null, url)
    },
    showThirdParty(item) {
      switch (item) {
        case 'normal':
          return (this.loginWorkWeixin || this.loginDing || this.loginLdap) && this.loginType !== 'normal'
        case 'wechatwork':
          return this.loginWorkWeixin
        case 'dingTalk':
          return this.loginDing
        case 'ldap':
          return this.loginLdap
        case 'rtxwechat':
          return this.loginRtxWeixin
      }
    },
    handleSolutionChange(item) {
      this.register = item.register
      this.loginDing = item.loginDing
      this.loginLdap = item.loginLdap
      this.loginWorkWeixin = item.loginWorkWeixin
      this.loginRtxWeixin = item.loginRtxWeixin
      this.showCode = item.loginCaptcha
      localStorage.setItem('client-solutionId', this.loginForm.solution)
      this.setUrlKey('sid', item.id.split('-')[0])
      this.wxAppid = null
      this.agentid = null
      this.dingTalkAppid = null
    },
    handleLoginType(type) {
      this.loginType = type
    },
    // 获取重定向
    getRedirect() {
      this.redirect_uri = window.location.host // + '/SSO'
    },
    // 获取第三方信息
    getThirdParty(type) {
      getThirdParty(this.loginForm.solution, type).then(response => {
        if (type === 2) {
          this.wxState = response.data.state
          this.wxAppid = response.data.appId
          this.agentid = response.data.agentId
        } else if (type === 3) {
          this.dingState = response.data.state
          this.dingTalkAppid = response.data.appId // 'dingoafc2chwuzrucpe0xa'
        } else if (type === 4) {
          this.rtxApiHost = response.data.apihost
          this.wxState = response.data.state
          this.rtxAppid = response.data.appId
          this.agentid = response.data.agentId
        }

        this.thirdPartyLoading = false
      }).catch(() => {
        this.thirdPartyLoading = false
      })
    },
    handleRegister() {
      this.$router.replace('/register')
    },
    handleResetPwd() {
      this.$router.replace('/reset-pwd')
    },
    setRememberMe(loginForm, useCookie) {
      localStorage.setItem('loginForm', JSON.stringify(loginForm), { expires: 365 })
      localStorage.setItem('useCookie', useCookie, { expires: 365 })
    },
    removeRememberMe() {
      localStorage.removeItem('loginForm')
      localStorage.removeItem('useCookie')
    },
    getOEMInfo() {
      getOEMInfo().then(response => {
        if (response.data) {
          this.$store.dispatch('setOEMInfo', response.data)
        }
      })
    },
    getSolutions() {
      const that = this
      if (this.getSolutionCount > 10) {
        if (this.waitingNotify) {
          this.waitingNotify.close()
        }
        this.$notify.error({
          title: this.$t('status.error'),
          message: this.$t('login.noAccount'),
          duration: 0
        })
        return
      }
      this.getSolutionCount += 1
      getSolutions().then(response => {
        that.options = response.data
        setSolutionList(that.options)
        if (that.defaultSid) {
          var findResult = that.options.find(item => item.id.toUpperCase().indexOf(that.defaultSid.toUpperCase()) === 0)
          if (!findResult) {
            that.$notify.error({
              title: that.$t('status.error'),
              message: that.$t('login.noSolution'),
              duration: 0
            })
            return
          } else {
            that.defaultSid = findResult.id
          }
        }
        this.loginType = this.defaultLoginType || localStorage.getItem('loginType') || 'normal'
        var SolutionId = this.defaultSid || getSolutionId()
        if (SolutionId !== '') {
          for (var i = 0; i < this.options.length; i++) {
            if (this.options[i].id === SolutionId) {
              this.loginForm.solution = this.options[i].id
              this.register = this.options[i].register
              this.loginDing = this.options[i].loginDing
              this.loginLdap = this.options[i].loginLdap
              this.loginWorkWeixin = this.options[i].loginWorkWeixin
              this.loginRtxWeixin = this.options[i].loginRtxWeixin
              this.showCode = this.options[i].loginCaptcha
              this.getSolutionCount = 0
              if (this.waitingNotify) {
                this.waitingNotify.close()
              }
              this.setUrlKey('sid', this.loginForm.solution.split('-')[0])
              return
            }
          }
        }
        if (SolutionId || this.options[0]) {
          localStorage.setItem('client-solutionId', SolutionId || this.options[0].id)
        }
        if (this.options.length > 0) {
          this.loginForm.solution = this.options[0].id
          this.register = this.options[0].register
          this.loginDing = this.options[0].loginDing
          this.loginLdap = this.options[0].loginLdap
          this.loginWorkWeixin = this.options[0].loginWorkWeixin
          this.loginRtxWeixin = this.options[0].loginRtxWeixin
          this.showCode = this.options[0].loginCaptcha
          this.getSolutionCount = 0
          if (this.waitingNotify) {
            this.waitingNotify.close()
          }
          this.setUrlKey('sid', this.loginForm.solution.split('-')[0])
        } else {
          setTimeout(() => {
            this.getSolutions()
            if (!this.waitingNotify) {
              this.waitingNotify = this.$notify.info({
                title: this.$t('status.prompt'),
                message: this.$t('login.gettingSolutions'),
                duration: 30000
              })
            }
          }, 3000)
        }
      })
    },
    showPwd() {
      if (this.pwdType === 'password') {
        this.pwdType = ''
      } else {
        this.pwdType = 'password'
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          localStorage.setItem('client-solutionId', this.loginForm.solution)
          const encryptLoginForm = JSON.parse(JSON.stringify(this.loginForm))
          const removeEqual = (str) => {
            if (str[str.length - 1] === '=') {
              str = str.substring(0, str.length - 1)
              return removeEqual(str)
            }
            return str
          }
          encryptLoginForm.password = removeEqual(window.btoa(encryptLoginForm.password))
          encryptLoginForm.params = this.loginParams
          this.$store.dispatch('Login', encryptLoginForm).then(data => {
            // 记录下用户名和账套ID
            if (this.useCookie) {
              this.setRememberMe(this.loginForm, this.useCookie)
            } else {
              this.removeRememberMe()
            }
            this.$store.dispatch('setSolutionId', this.loginForm.solution)
            if (data.improve_pwd) {
              this.$confirm(`${data.improve_dec.join('<br />')}`, this.$t('login.expired'), {
                dangerouslyUseHTMLString: true,
                distinguishCancelAndClose: true,
                cancelButtonText: this.$t('login.return'),
                confirmButtonText: this.$t('login.goTo')
              })
                .then(() => {
                  this.$store.dispatch('setImprovePwd', this.loginForm.password)
                  this.$router.push('/impove-pwd')
                })
                .catch(() => { })
              this.loading = false
            } else {
              this.$store.dispatch('delAllViews')
              localStorage.removeItem('lastTab')
              var directPath = '/'
              // 支持跳转指定路由
              if (this.getUrlKey('redirect')) {
                directPath = this.getUrlKey('redirect')
              }
              // 整理参数并拼接到路由中
              var paramTemp = decodeURIComponent(location.href).split('?')
              var paramStr = '?'
              if (paramTemp.length) {
                var paramList = paramTemp[1].split('&')
                paramList = paramList.filter(item => item.indexOf('redirect=') < 0)
                if (paramList.length) {
                  paramStr += '&' + paramList.join('&')
                }
              }
              this.$router.push(directPath + (paramStr.length > 1 ? paramStr : ''))
            }
          })
            .catch((error) => {
              // 重定向
              if (error.retcode === 302) {
                window.location.href = error.data
              }
              if (error.retcode === 2063) {
                this.$message.error(error.msg)
              }
              if (this.showCode) {
                this.time = new Date().getTime()
              }
              this.loading = false
            })
        } else {
          // this.$message.error('请输入正确的登录信息')
          return false
        }
      })
    },
    setCookie(c_name, value, expiredays) {
      var exdate = new Date()
      exdate.setDate(exdate.getDate() + expiredays)
      document.cookie = c_name + '=' + escape(value) +
        ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
    },
    getCookie(c_name) {
      var c_start, c_end
      if (document.cookie.length > 0) {
        c_start = document.cookie.indexOf(c_name + '=')
        if (c_start !== -1) {
          c_start = c_start + c_name.length + 1
          c_end = document.cookie.indexOf(';', c_start)
          if (c_end === -1) c_end = document.cookie.length
          return unescape(document.cookie.substring(c_start, c_end))
        }
      }
      return ''
    },
    // 获取登录页面样式信息
    getLoginViewSettings(val) {
      getTimestamps(val).then(response => {
        this.timestamps = response.data
        setHash(this.timestamps)
      })
      getSystemSettings(val).then(response => {
        if (response.status >= 200 && response.status < 300) {
          this.title = response.data.systemLoginName ? response.data.systemLoginName : this.title
          document.title = this.title
          this.effectActive = response.data.animation
        } else {
          this.errorMessage(this.$t('login.styleError') + response.data)
          console.error(response)
        }
      }).catch((exception) => {
        this.errorMessage(this.$t('login.styleError') + (exception.response.status !== 500 ? exception.response.data : this.$t('report.unknown')))
      })
    },

    getFootContent() {
      getGlobalSetting('footContent').then(response => {
        if (response.data) {
          this.footContent = Object.assign(this.footContent, response.data)
        }
        this.loading = false
      })
    },

    errorMessage(message) {
      if (message instanceof Array) {
        var messageStr = message[0]
        for (var i = 1; i < message.length; i++) {
          messageStr += '<br >' + message[i]
        }
        message = messageStr
      }
      this.$message({
        dangerouslyUseHTMLString: true,
        showClose: true,
        message: message,
        type: 'error',
        duration: 2 * 1000
      })
      console.error(new Date() + message)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
$bg: #fff;
$color: #dcdfe6;
.borderColor {
  border-color: #409eff !important;
}
/* reset element-ui css */
.login-container {
  .thirdParty {
    position: relative;
    z-index: 99;
    text-align: center;
    .svg-icon {
      width: 36px !important;
      height: 36px !important;
    }
  }
  svg {
    display: inline-block;
    margin-top: -5px;
  }
  .el-select {
    width: calc(100% - 35px);
    .el-input {
      width: 100%;
    }
    .el-input__icon {
      color: $color;
      font-size: 16px;
    }
  }
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;
    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: #666;
      height: 47px;
      &:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: #666 !important;
      }
    }
  }
  .el-form-item {
    border-radius: 4px;
    border: none;
    color: #000;
    border: 1px solid #dcdfe6;
    position: relative;
    z-index: 999;
    transition: 0.3s;
    .catcha {
      position: absolute;
      right: 5px;
      top: 8px;
      cursor: pointer;
    }
  }
  .el-form-item:last-child {
    border: none;
  }
  .el-form-item .el-button {
    margin-top: 18px;
  }
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
$bg: #fff;
$dark_gray: #000;
$light_gray: #000;
.login-container {
  position: fixed;
  height: 100%;
  width: 100%;
  overflow: auto;
  background-repeat: no-repeat;
  background-size: cover;
  .el-breadcrumb {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    line-height: 32px;
  }
  .el-breadcrumb__item {
    float: none;
    font-size: 12px;
    cursor: pointer;
    a {
      color: #666;
      font-weight: normal;
      cursor: pointer;
    }
  }
  .login-form {
    position: absolute;
    left: 0;
    right: 0;
    width: 520px;
    padding: 35px 35px 15px 35px;
    margin: 9% auto;
    z-index: 999;
  }
  .login-form:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.8);
    filter: blur(2px);
    border-radius: 4px;
  }
  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;
    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }
  .svg-container {
    padding: 6px 5px 6px 15px;
    color: #c0c4cc;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
    &_login {
      font-size: 20px;
    }
  }
  .title {
    font-size: 18px;
    font-weight: 400;
    margin: 10px auto 30px auto;
    width: 100%;
    text-align: center;
    position: relative;
    z-index: 999;
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
  p.logo {
    position: relative;
    z-index: 999;
    text-align: center;
    img {
      max-height: 8rem;
      display: inline-block;
    }
  }
}
.foot_content {
  position: fixed;
  bottom: 3%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
}
</style>
